const SITE_DOMAIN = import.meta.env.VITE_SITE_DOMAIN;
const AUTH_DOMAIN = import.meta.env.VITE_AUTH_DOMAIN;

function safeOrigin(value: string | undefined): string | null {
  if (!value) return null;

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
}

export function getSafeRedirectTarget(redirectTo: string | null | undefined): string {
  const fallback = SITE_DOMAIN || "/";

  if (!redirectTo) {
    return fallback;
  }

  try {
    const target = new URL(redirectTo, window.location.origin);
    const allowedOrigins = new Set(
      [window.location.origin, safeOrigin(SITE_DOMAIN), safeOrigin(AUTH_DOMAIN)].filter(
        (origin): origin is string => Boolean(origin),
      ),
    );

    if (!allowedOrigins.has(target.origin)) {
      return fallback;
    }

    return target.toString();
  } catch {
    return fallback;
  }
}
